import {Controller} from "@hotwired/stimulus"

// A panel that can be closed, and optionally closes itself.
//
// after: seconds before it fades on its own; omit for one that only closes when
// asked. The timer pauses while the pointer is over the panel — an alert that
// disappears mid-sentence is worse than one that stays, and the whole point of a
// timer is to clear things nobody is reading.
export default class extends Controller {
    static values = {after: Number}

    connect() {
        if (this.afterValue > 0) this.start()
    }

    disconnect() {
        this.stop()
    }

    start() {
        this.stop()
        this.timer = setTimeout(() => this.close(), this.afterValue * 1000)
    }

    stop() {
        if (this.timer) clearTimeout(this.timer)
        this.timer = null
    }

    close() {
        this.stop()
        this.element.style.transition = "opacity 250ms"
        this.element.style.opacity = "0"
        setTimeout(() => this.element.remove(), 250)
    }
}
